import React from 'react'

import { DefaultMediaWizardLayout } from './DefaultMediaWizardLayout'

import { MediaAcademy as MediaAcademyComponent } from 'components/MediaAcademy'
import { Breadcrumb } from 'components/Links'

import { useDocumentTitle } from '@percept/hooks'


const breadcrumbs: Breadcrumb[] = [
  {
    path: '/wizard/optimisation',
    name: 'Optimisation',
  },
  {
    path: '/wizard/optimisation/media-academy',
    name: 'Media Academy',
  },
]


export const MediaAcademy = (): JSX.Element => {
  useDocumentTitle({ paths: ['Optimisation', 'Media Academy'] })
  return (
    <DefaultMediaWizardLayout
      breadcrumbs={breadcrumbs}>

      <MediaAcademyComponent />

    </DefaultMediaWizardLayout>
  )
}
